import React from 'react';
import {Route} from 'react-router-dom';
import {withTracking} from '@ezcater/tracking-react';

const EzManageRouteNoAuth = ({component: Component, linkId, path}) => {
  return <Route linkId={linkId} component={Component} path={path} />;
};

export default withTracking(EzManageRouteNoAuth);
